import { Attachment } from "airtable"
import DetailImages from "./detailImages"
import PageTitle from "../pageTitle"
import { Information } from "./information"
import ContextualImages from "./contextual"
import WorksNav from "../workIndex/worksNav"
import { Dispatch, SetStateAction, useState } from "react"
import ReactMarkdown from "react-markdown"
import { StyledBodyText } from "../bodyText"
import tw from "twin.macro"
import { useCTX } from "../../util/context"
import { WorkImage } from "./workImage"
import { NextPrevious } from "./nextPrevious"

export interface WorksFields {
  id: string
  record_id: string
  title: string
  image_url: string
  image_preview: Array<Attachment>
  information: string
  caption: string
  description: string
  credit?: string
  size: number
  zoom?: boolean
  detail_images: Attachment[]
  category?: Array<string>
  worksNav: string
  setWorksNav: Dispatch<SetStateAction<string>>
  paginationData?: Array<any>
  overviewData?: Array<any>
  contextual_image_url?: Array<string>
  contextual_caption?: Array<string>
}

const WorkIndex = (props: WorksFields) => {
  const {
    id,
    title,
    information,
    description,
    caption,
    credit,
    worksNav,
    image_url,
    image_preview,
    setWorksNav,
    paginationData,
    overviewData,
    record_id,
    category,
    contextual_image_url,
    contextual_caption,
  } = props

  const { workctx } = useCTX()
  const [workCtxData] = useState(workctx == "overview" ? overviewData : paginationData)
  const [imageLoaded, setImageLoaded] = useState(false)

  const workImageProps = { image_url, image_preview, title, caption, setImageLoaded }
  const nextPreviousProps = { category, workCtxData, record_id, worksNav }

  return (
    <>
      <section id={id} tw="py-10 space-y-10">
        <div tw="max-w-screen-desktop-lg desktop-lg:mx-auto px-4 relative">
          <div tw="grid grid-cols-4 tablet-lg:(grid-cols-12) gap-4 desktop:(gap-6 gap-y-0)">
            <div tw="col-span-4 tablet-lg:col-span-12">
              <PageTitle title="Works" />
              <WorksNav {...{ worksNav, setWorksNav }} />
            </div>

            <div tw="col-span-4 tablet-lg:col-span-12 relative">
              <div tw="py-4 tablet:py-10 flex flex-col items-center space-y-14">
                <div tw="flex flex-col items-center space-y-4 ">
                  {workCtxData && <NextPrevious {...nextPreviousProps} />}
                  <WorkImage {...workImageProps} />
                </div>

                <DetailImages {...props} />
                <div tw="space-y-2">
                  <h1 tw="font-display text-2xl font-normal text-center" css="letter-spacing: 0.01em;">
                    {title}
                  </h1>
                  <div tw="tablet:(w-mobile-lg mx-auto)">
                    <Information label={information} center />
                    {credit && (
                      <div tw="text-xs font-sans text-center">
                        <ReactMarkdown>{credit}</ReactMarkdown>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {description && (
              <div tw="col-span-4 tablet-lg:(col-span-8 col-start-3)">
                <StyledBodyText>
                  <div>
                    <ReactMarkdown>{description}</ReactMarkdown>
                  </div>
                </StyledBodyText>
              </div>
            )}

            {contextual_image_url && (
              <div tw="col-span-4 tablet-lg:(col-span-12)">
                <div>
                  <div tw="pt-8 tablet:(py-12) flex flex-col items-center justify-center space-y-12">
                    <ContextualImages
                      record_id={record_id}
                      contextual_image_url={contextual_image_url}
                      contextual_caption={contextual_caption}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  )
}

export default WorkIndex
